export const displayPin = {
    displayedOnExternalDevice: true,
};
